module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/worldwide-location-icon-d01bd4eaa2d991b71760e1a78dbe1822.png";